/**
 * The design palette (docs/Springcast Player.html): the default look of every page on PlayerCore.
 */
export const DESIGN_PALETTE = {
    "--vp-ink": "#15120d",
    "--vp-paper": "#fbf9f5",
    "--vp-muted": "#cfc8bc",
    "--vp-accent": "#a48cdc",
    "--vp-panel": "rgba(21, 18, 13, 0.92)",
    "--vp-cta": "#f2a52e",
    "--vp-cta-text": "#15120d",
    "--vp-brand": "#4a2bb8",
    "--vp-caption-on": "#f4be5e",
}
